import { type App } from "vue"
import { serviceRegistry } from "@services/register"

// Génère automatiquement les méthodes à injecter à partir du serviceRegistry
function getServiceMethods(registry: typeof serviceRegistry) {
    const methods: Record<string, (...args: any[]) => any> = {}

    for (const serviceInstance of Object.values(registry)) {
        // On récupère toutes les méthodes propres à l'instance (hors héritées d'Object)
        const proto = Object.getPrototypeOf(serviceInstance)
        const propertyNames = Object.getOwnPropertyNames(proto)
        for (const name of propertyNames) {
            if (
                name !== "constructor" &&
                typeof (serviceInstance as any)[name] === "function"
            ) {
                // On préfixe par $ et on évite les doublons
                const methodName = `$${name}`
                if (!methods[methodName]) {
                    methods[methodName] = (serviceInstance as any)[name].bind(
                        serviceInstance
                    )
                }
            }
        }
    }
    return methods
}

export default {
    install: (app: App) => {
        const serviceMethods = getServiceMethods(serviceRegistry)

        // Ajout sur globalProperties
        for (const [key, fn] of Object.entries(serviceMethods)) {
            app.config.globalProperties[key] = fn
        }

        // Provide global "services" object
        app.provide("services", serviceMethods)
    },
}
